import { Icon } from 'shared';

export const mockFooterLinks = [
  {
    link: 'https://twitter.com/mogulofficial_',
    icon: <Icon type="twitter" />,
  },
  {
    link: 'https://www.facebook.com/mogulproduction/?view_public_for=110028973737735',
    icon: <Icon type="facebook" />,
  },
  {
    link: 'https://www.instagram.com/mogul.official/',
    icon: <Icon type="instagram" />,
  },
  {
    link: 'https://t.me/mogulproductions',
    icon: <Icon type="telegram" />,
  },
  {
    link: 'https://www.reddit.com/r/mogulproductions/',
    icon: <Icon type="reddit" />,
  },
  {
    link: 'https://discord.gg/MogulProductions',
    icon: <Icon type="discord" />,
  },
];
